import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessListingPage {
  accessFilter: AccessReportsWizardOption;
  accessListing: boolean;
  columns: AccessReportsWizardOption[];
  graphMiles: string;
  id: number;
  maxCount: string;
  maxMiles: string;
  maxMinutes: string;
  minCount: string;

  constructor(accessListing: boolean, id: number) {
    this.accessFilter = null;
    this.accessListing = accessListing;
    this.columns = [];
    this.graphMiles = null;
    this.id = id;
    this.maxCount = "";
    this.maxMiles = "";
    this.maxMinutes = "";
    this.minCount = "";
  }
}

export { AccessListingPage };
